import React from 'react';
import { Table, Input, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { PendingItem } from '../../../services/pwd216Api';

const { TextArea } = Input;

interface Props {
  items: PendingItem[];
  loading: boolean;
  checkedKeys: string[];
  selectedDocNo: string | null;
  onCheckedChange: (keys: string[]) => void;
  onSelect: (docNo: string | null) => void;
  onAnomalyDescChange: (docNo: string, desc: string) => void;
  isEditing: boolean;
}

const Pwd216PendingList: React.FC<Props> = React.memo(
  ({ items, loading, checkedKeys, selectedDocNo, onCheckedChange, onSelect, onAnomalyDescChange, isEditing }) => {
    const columns: ColumnsType<PendingItem> = [
      {
        title: <span data-contract-field="ui_doc_no">單號</span>,
        dataIndex: 'doc_no',
        key: 'doc_no',
        width: 120,
        render: (text: string) => <span style={{ fontFamily: 'monospace' }}>{text}</span>,
      },
      {
        title: <span data-contract-field="ui_doc_type">單據別</span>,
        dataIndex: 'doc_type',
        key: 'doc_type',
        width: 80,
        align: 'center',
        render: (v: string) => <Tag color={v === 'D202' ? 'blue' : 'orange'}>{v}</Tag>,
      },
      {
        title: <span data-contract-field="ui_doc_date">單據日期</span>,
        dataIndex: 'doc_date',
        key: 'doc_date',
        width: 110,
        render: (date: string) =>
          date ? new Date(date).toLocaleDateString('zh-TW') : '--',
      },
      {
        title: <span data-contract-field="ui_vendor_code">廠商代號</span>,
        dataIndex: 'vendor_code',
        key: 'vendor_code',
        width: 100,
      },
      {
        title: <span data-contract-field="ui_anomaly_desc">異常說明</span>,
        dataIndex: 'anomaly_desc',
        key: 'anomaly_desc',
        render: (text: string, record: PendingItem) =>
          isEditing && checkedKeys.includes(record.doc_no) ? (
            <TextArea
              value={text}
              onChange={(e) => onAnomalyDescChange(record.doc_no, e.target.value)}
              autoSize={{ minRows: 1, maxRows: 3 }}
              style={{ width: '100%' }}
            />
          ) : (
            <span>{text || '--'}</span>
          ),
      },
      {
        title: <span data-contract-field="ui_detail_count">明細數</span>,
        key: 'detail_count',
        width: 70,
        align: 'center',
        render: (_: unknown, record: PendingItem) => record.details?.length || 0,
      },
    ];

    const rowSelection = {
      selectedRowKeys: checkedKeys,
      onChange: (keys: React.Key[]) => onCheckedChange(keys as string[]),
    };

    return (
      <Table<PendingItem>
        rowKey="doc_no"
        columns={columns}
        dataSource={items}
        loading={loading}
        rowSelection={rowSelection}
        size="small"
        pagination={false}
        scroll={{ y: 260 }}
        onRow={(record) => ({
          onClick: () => onSelect(record.doc_no === selectedDocNo ? null : record.doc_no),
          style: {
            cursor: 'pointer',
            background: record.doc_no === selectedDocNo ? '#e6f7ff' : undefined,
          },
        })}
        locale={{ emptyText: '請輸入單號範圍後按「確定範圍」查詢' }}
      />
    );
  },
);

Pwd216PendingList.displayName = 'Pwd216PendingList';
export default Pwd216PendingList;
